/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { Box, InputAdornment, Tooltip } from '@mui/material';
import BaseInput from './BaseInput';

const IconTooltipTextField = ({
    iconStart,
    startText,
    iconEnd,
    endText,
    InputProps,
    ...props
}: any) => {
    const iconEndModified = (
        <Tooltip title={endText} followCursor>
            <Box component="span" sx={{ display: 'inline-flex' }}>
                {iconEnd}
            </Box>
        </Tooltip>
    );
    const iconStartModified = (
        <Tooltip title={startText} followCursor>
            <Box component="span" sx={{ display: 'inline-flex' }}>
                {iconStart}
            </Box>
        </Tooltip>
    );

    return (
        <BaseInput
            sx={{
                '& .MuiOutlinedInput-root': {
                    paddingRight: '10px !important',
                },
            }}
            {...props}
            slotProps={{
                ...props.slotProps,
                input: {
                    ...InputProps,
                    startAdornment: iconStart ? (
                        <InputAdornment position="start">{iconStartModified}</InputAdornment>
                    ) : null,
                    endAdornment: iconEnd ? (
                        <InputAdornment position="end">{iconEndModified}</InputAdornment>
                    ) : null,
                },
            }}
        />
    );
};

export default IconTooltipTextField;
